import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseUrl=environment.apiURL;
  constructor(
    private http:HttpClient
  ) { }

  getUserDeviceIds(data:any):Observable<Object>{
    return this.http.post(this.baseUrl+'dashboard/getUserDeviceIds',data)
  }

  getOperationList(data:any):Observable<Object>{
    return this.http.post(this.baseUrl+'dashboard/getOperationList',data)
  }

  getViewGraphData(data:any):Observable<Object>{
    return this.http.post(this.baseUrl+'dashboard/getViewGraphData',data)
  }

}
